export default __webpack_public_path__ + "static/media/logo-armazem-do-vinho2.46292ca7.png";